module.exports = __webpack_public_path__ + "img/recording.b73af575.svg";